import { getEnvironment } from "@lib/getEnvironment";

/**
 * Get background map image for client for Onboarding.
 */
const getMapUrl = () => {
  const environment = getEnvironment();
  if (environment === "development") {
    // Shortcut for local dev to not hit Google API.
    return "/images/onboarding/default-onboarding-background.png";
  }

  const lat = VisitWidget.settings.defaultCoordinates.latitude;
  const lng = VisitWidget.settings.defaultCoordinates.longitude;
  const zoom = VisitWidget.settings.currentClientMapZoomLevel;

  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=400x600&maptype=roadmap&&key=${VisitWidget.settings.mapBrowserApiKey}&style=feature:poi|visibility:off&style=feature:transit|visibility:off`;
};

export { getMapUrl };
